{
  "en": {
    "decision_type": {
      "actions": {
        "add_competitor": "Add competitor",
        "add_decision_partners": "Decision partners",
        "change_rights": "Change rights",
        "create_category": "Add new category",
        "delete": "Delete",
        "deleteMultiple": "Delete...",
        "delete_cancel": "Cancel",
        "download": "Download",
        "edit": "Edit",
        "edit_decision_partners": "Edit decision partners",
        "import": "Import",
        "new": "New",
        "newDecision": "New decision",
        "newDecisions": "Decision",
        "save": "Save",
        "show": "Show",
        "start_new_group": "Start new group",
        "submit": "Submit"
      },
      "attributes": {
        "category": "Category",
        "created_at": "Created at",
        "description": "Description",
        "name": "Title",
        "responsible": "Responsible",
        "start_date": "Start date"
      },
      "labels": {
        "add_decision_partners": "Add decision partners",
        "allowCreditExplainer": "Show credit for decisions below budget",
        "auto_close": "Close decision automatically once deadline has passed",
        "auto_close_info": "Closing a decision prevents the customer from approving a proposal when no decision has been made. This is useful when you work with tight deadlines.",
        "category_name": "Category name",
        "closes_on_deadline": "Closes on deadline",
        "createNewPartner": "Or create new decision partner",
        "decision_type_category_description": "Assigning a category such as kitchen, bathroom etc. to multiple decisions will group them together and allow for better oversight",
        "deleteCategory": "Delete category {category}?",
        "deleteGroupSubtitle": "This will remove all the conversations, proposals and documents created by everyone in {group_name} from {decision_type_name}.",
        "deleteGroupTitle": "You are about to delete {group_name}",
        "disclaimerDeleteGroup": "Deleting {group_name} will unpublish all decisions for the decision partners. You can publish to decision partners again once this decision has decision partners again.",
        "disclamerDeleteCategory": "Deleting {category} will remove the category from all decisions assigned to it. The decisions will not be deleted.",
        "editCategory": "Edit category",
        "editGroup": "Edit {group_name}",
        "editPartnerRights": "Edit decision partner communication rights",
        "editPartnerRightsLater": "You can always change this later",
        "existing_groups": "Existing partner groups",
        "explainerPartners": "Add external decision partners and work together on {decision_type_name}",
        "export_preparing": "Collecting all proposals can take up to a few minutes. You’ll receive a notification when it’s ready to download.",
        "export_proposals_approved": "Documents approved proposals",
        "groupRightsWarning": "Be warned! All conversations between the Customer and the Partners will be removed. This action is irreversible. Are you sure you want to continue?",
        "hint": "You can manage your categories in the",
        "hintSettings": "company settings.",
        "last_updated_at": "Last updated at",
        "matrix": "Statistics",
        "new_category": "New decision category",
        "noPartnersAddedYet": "No decision partners added yet",
        "noResultPartner": "No results for {partner_name}",
        "partner_group": "Partner Group",
        "partners": "Decision partners",
        "projectUnitsTotal": "{project_name} has {units_count_max} units in total",
        "proposal_uploaded": "proposal uploaded",
        "published_state": "Published status",
        "searchPartners": "Search decision partners",
        "selectADecision": "Select a decision",
        "select_decision_partners": "Select your decision partners",
        "setUpPartners": "Set up decision partners",
        "set_rights": "Set Group Rights for {partner_group_name}",
        "start_date_description": "Date for internal use only. This could be used to determine the order in which decisions are worked on by your team",
        "start_date_title": "Start date (optional)",
        "step0Title": "Which template project and decision do you want to use?",
        "step1Title": "What kind of decision do your customers need to make?",
        "tab_proposal_templates": "Proposal Templates",
        "tab_units": "Units",
        "upsellCategoryTypes": "This feature is not included in your package. Contact us through the blue button to find out more.",
        "view": "View",
        "view_list": "List",
        "view_table": "Table",
        "writeEmployeeNameReject": "Write <i><b>{employeeName}</b></i> to continue."
      },
      "snackbars": {
        "duplicate": "Decision has been created, however the copying process from the template might take a few minutes to complete."
      },
      "toasts": {
        "bulk_delete": "Decision successfully deleted | Decisions successfully deleted",
        "update": "Decision successfully updated"
      },
      "validation": {
        "duplicateNameAlreadyTaken": "'{name}' is already taken for this project",
        "nameAlreadyTaken": "Name is already taken for this project",
        "needName": "Title is required",
        "projectRequired": "Select a project first",
        "selectDecisionType": "Select at least 1 decision",
        "selectSharingOption": "Please select who you want to share the document(s) with"
      }
    }
  }
}